import React from 'react'
import { SimpleTable } from 'components/Ui'
import InfoField from 'components/Ui/InfoField'
import dayjs from 'dayjs'

const ViewDetails = (props) => {
    const { company, users } = props

    return (
        <div className="grid grid-cols-1 gap-4 h-[350px] overflow-y-auto">
            <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center">
                <div className="flex flex-row justify-between gap-4">
                    <h5 className="font-bold">
                        Company - {company?.company?.name ?? company?.name}
                    </h5>
                </div>
            </div>
            <hr className="my-4" />
            <div className="grid grid-cols-1 gap-4">
                <InfoField
                    title="Total Lines"
                    value={
                        company?.total_lines_processed
                            ? company?.total_lines_processed +
                              company?.total_lines_remaining
                            : 0
                    }
                />
                <InfoField
                    title="Total Lines Remaining"
                    value={company?.total_lines_remaining ?? 0}
                />
                <InfoField
                    title="Total Lines Processed"
                    value={company?.total_lines_processed ?? 0}
                />
                <InfoField
                    title="Start Date"
                    value={
                        company?.start_date
                            ? dayjs(company?.start_date).format('DD-MMM-YYYY')
                            : ''
                    }
                />
                <InfoField
                    title="End Date"
                    value={
                        company?.month
                            ? dayjs(company?.month).format('DD-MMM-YYYY')
                            : ''
                    }
                />
                <InfoField
                    title="Total Allowed Users"
                    value={company?.user_num ?? 0}
                />
            </div>
            <div>
                <h5 className="mb-4">User Usage</h5>
                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                    <SimpleTable>
                        <thead>
                            <SimpleTable.TR>
                                <SimpleTable.TH>User Name</SimpleTable.TH>
                                <SimpleTable.TH>Total Lines</SimpleTable.TH>
                                <SimpleTable.TH>
                                    Total Lines Remaining
                                </SimpleTable.TH>
                                <SimpleTable.TH>
                                    Total Lines Processed
                                </SimpleTable.TH>
                            </SimpleTable.TR>
                        </thead>
                        <tbody>
                            {(users ?? [])?.map((item, index) => (
                                <SimpleTable.TR key={`asn-${index}`}>
                                    <SimpleTable.TD>{`${item?.user?.first_name} ${item?.user?.last_name}`}</SimpleTable.TD>
                                    <SimpleTable.TD>
                                        {item?.lines_processed +
                                            item?.lines_remaining}
                                    </SimpleTable.TD>
                                    <SimpleTable.TD>
                                        {item?.lines_remaining}
                                    </SimpleTable.TD>
                                    <SimpleTable.TD>
                                        {item?.lines_processed}
                                    </SimpleTable.TD>
                                </SimpleTable.TR>
                            ))}
                        </tbody>
                    </SimpleTable>
                </div>
            </div>
        </div>
    )
}

export default ViewDetails
